module.exports = require("./lib/_stream_transform.js")



//////////////////
// WEBPACK FOOTER
// (webpack)/~/readable-stream/transform.js
// module id = 427
// module chunks = 1 4 5 6 8 9 10 12 13 14 19 21 24 27 28 57